import { isFilled } from "@prismicio/client";
import { PrismicImage, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.CardsSlice} CardsSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<CardsSlice>} CardsProps
 * @type {import("react").FC<CardsProps>}
 */
const Cards = ({ slice, index }) => {

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`framing padding-x ${index === 0 ? "padding-y-first" : "padding-y"} flex flex-col gap-6 md:gap-10 text-black`}
    >
      {isFilled.richText(slice.primary.title) && (
        <div className="flex flex-col gap-2">
          <PrismicRichText
            field={slice.primary.title}
          />
        </div>
      )}
      <div className="flex flex-col xl:flex-row gap-4 md:gap-6">
        <div className="xl:w-1/2">
          {Array.isArray(slice.primary.cards) && slice.primary.cards.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-2 gap-4 h-full">
              {slice.primary.cards.map((card, index) => (
                <div key={index} className="bg-gray h-full rounded-lg p-6 flex flex-col gap-6">
                  <div className="flex gap-3 items-center">
                    {isFilled.image(card.picto) && (
                      <PrismicImage className="w-12 h-12"
                        field={{
                          ...card.picto,
                          alt: card.picto.alt || "Image d'illustration",
                        }}
                      />
                    )}

                    {isFilled.keyText(card.title) && <h3 className="h4">{card.title}</h3>}
                  </div>
                  {isFilled.richText(card.description) && (
                    <PrismicRichText
                      field={card.description} components={{
                        paragraph: ({ children }) => <p className="p-sm">{children}</p>,
                      }} />
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        {isFilled.image(slice.primary.img) && (
          <div className="hidden md:block flex-1">
            <PrismicImage
              className="rounded-2xl object-cover h-full w-full max-h-180"
              field={{
                ...slice.primary.img,
                alt: slice.primary.img.alt || "Image d'illustration",
              }}
            />
          </div>
        )}

        {isFilled.image(slice.primary.img_mobile) && (
          <PrismicImage
            className="md:hidden rounded-2xl object-cover h-full w-full max-h-100"
            field={{
              ...slice.primary.img_mobile,
              alt: slice.primary.img_mobile.alt || "Image d'illustration",
            }}
          />
        )}
      </div>
    </section>
  );
};

export default Cards;
